import regexList from "./utils/regexList";
import regexTest from "./utils/regexTest";

export default function isLength(str, responseText) {
    const regVal = regexList.length.pattern;
    return regexTest(str, regVal, responseText) || regexList.length.response;
}